// FILE: lib/wallet-client.ts
// LÀM GÌ? Helper client: kiểm tra đơn PayOS + đồng bộ số dư vào DiamondsContext.
// VÌ SAO TỒN TẠI? Dùng chung cho popup QR (polling) và trường hợp quay về từ app ngân hàng (?topup=).
// DB SCHEMA LIÊN QUAN? payment_orders (qua /api/wallet/verify-payment → RPC complete_payment_order idempotent), users.diamonds (qua /api/wallet/balance)
// FILE NÀO DÙNG NÓ? components/wallet/TopupQrModal.tsx, hooks/useTopupReturn.ts
"use client";

export type TopupStatus = "paid" | "pending" | "cancelled" | "error";

export async function verifyTopup(orderCode: number): Promise<TopupStatus> {
  try {
    const res = await fetch("/api/wallet/verify-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ orderCode }),
    });
    const d = await res.json();
    if (d?.success) return "paid";
    if (d?.status === "CANCELLED" || d?.status === "EXPIRED") return "cancelled";
    return res.ok ? "pending" : "error";
  } catch {
    return "error";
  }
}

/** Lấy số dư thật từ server, bù chênh lệch vào context (topbar tự animate). */
export async function syncBalance(
  current: number,
  addDiamonds: (amount: number, reason: any) => void,
): Promise<number> {
  try {
    const res = await fetch("/api/wallet/balance", { cache: "no-store" });
    const d = await res.json();
    const real = Number(d?.balance ?? current);
    if (real !== current) addDiamonds(real - current, "nap_payos");
    return real;
  } catch {
    return current;
  }
}